import React, { CSSProperties, useEffect, useRef, useState } from 'react';

import { Size } from 'coreOld/enums';

import SelectionPanelView from './SelectionPanelView';

interface IProps {
  isOpen?: boolean;
  onClose?: () => void;
  title: string;
  children?: React.ReactNode | React.ReactNode[];
  style?: CSSProperties;
  fontSize?: Size;
}

const SelectionPanel = ({ isOpen, children, title, onClose, style, fontSize }: IProps) => {
  const [height, setHeight] = useState<number | undefined>(isOpen ? undefined : 0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      setHeight(ref.current?.getBoundingClientRect().height);

      return;
    }

    setHeight(0);
  }, [isOpen, ref.current, ref.current?.getBoundingClientRect().height]);

  return (
    <SelectionPanelView
      onClose={onClose}
      isOpen={isOpen}
      title={title}
      fontSize={fontSize}
      ref={ref}
      height={height}
      style={style}
    >
      {children}
    </SelectionPanelView>
  );
};

export default SelectionPanel;
